import { render } from "./ExerciseEditorWrapperSkeleton.vue?vue&type=template&id=40a1b9d3&ts=true"
import script from "./ExerciseEditorWrapperSkeleton.vue?vue&type=script&lang=ts"
export * from "./ExerciseEditorWrapperSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__